"use client";
import { Card, List, ListItem, ListItemPrefix } from "@material-tailwind/react";
import { UserCircleIcon, PowerIcon, HomeIcon } from "@heroicons/react/24/solid";
import Link from "next/link";
import { useRouter } from "next/navigation";
import apiSlice from "@/redux/slices/apiSlice";
import { useDispatch } from "react-redux";
import { useLogoutMutation } from "@/redux/slices/authSlice";
import { useContext } from "react";
import myContext from "@/context/myContext";
import { BookText, NotebookPen, UsersIcon } from "lucide-react";

export default function BlogManagerSidebar() {
  const dispatch = useDispatch();

  const { updateAuthState } = useContext(myContext);

  const [logout] = useLogoutMutation();

  const router = useRouter(); // Use useRouter instead of usePathname for navigation

  const handleLogout = async () => {
    await logout(); // Call the logout mutation to remove token
    updateAuthState();
    dispatch(apiSlice.util.resetApiState());
    router.push("/"); // Navigate after all other operations complete
  };

  return (
    <div className=" h-screen fixed w-full max-w-[16rem] p-4 rounded-none border-r border-r-teal-700 bg-teal-700">
      <div className="">
        <div className="mb-2 p-4">
          <Link href="home">
            <div className=" py-6">
              <div className="flex justify-center mb-2">
                <img
                  className="w-24"
                  src="https://cdn-icons-png.flaticon.com/128/12213/12213586.png"
                  alt="img"
                />
              </div>
              <h1 className="text-center text-xl text-white font-bold app-font">
                Blog Manager Dashboard
              </h1>
            </div>
          </Link>
        </div>
      </div>

      <List>
        <Link href={"home"}>
          <ListItem className="hover:bg-teal-50 active:bg-teal-100 text-white focus:bg-teal-100 transition-colors duration-300">
            <ListItemPrefix>
              <HomeIcon color="white" className="h-5 w-5" />
            </ListItemPrefix>
            Home
          </ListItem>
        </Link>

        <Link href={"view-blogs"}>
          <ListItem className="hover:bg-teal-50 text-white active:bg-teal-100 focus:bg-teal-100 transition-colors duration-300">
            <ListItemPrefix>
              <BookText color="white" className="h-5 w-5" />
            </ListItemPrefix>
            View Blogs
          </ListItem>
        </Link>

        <Link href={"add-blog"}>
          <ListItem className="hover:bg-teal-50 text-white active:bg-teal-100 focus:bg-teal-100 transition-colors duration-300">
            <ListItemPrefix>
              <NotebookPen color="white" className="h-5 w-5" />
            </ListItemPrefix>
            Add Blog
          </ListItem>
        </Link>

        <Link href={"profile-page"}>
          <ListItem className="hover:bg-teal-50 text-white active:bg-teal-100 focus:bg-teal-100 transition-colors duration-300">
            <ListItemPrefix>
              <UserCircleIcon color="white" className="h-5 w-5" />
            </ListItemPrefix>
            Profile
          </ListItem>
        </Link>

        <ListItem
          onClick={handleLogout}
          className="hover:bg-teal-50 text-white active:bg-teal-100 focus:bg-teal-100 transition-colors duration-300"
        >
          <ListItemPrefix>
            <PowerIcon color="white" className="h-5 w-5" />
          </ListItemPrefix>
          Log Out
        </ListItem>
        <Card className=" mb-5"></Card>
      </List>
    </div>
  );
}
